module.exports = __webpack_public_path__ + "static/apple-button-d5ad69afc5e5ee064cef573cdd5ff649.png";